import { createContext } from 'react'

import defaultProperties from './defaultProperties'

const SearchContext = createContext(
{
    ...defaultProperties
});

export default SearchContext ;